import { isLocalDevAppMode } from "./appMode";

export const SAMI_IAM_DEV_OVERRIDE_KEY = "sami_iam_dev_override";

export type SamiIamDevOverride = "on" | "off";

function parseEnvFlag(value: string | undefined): boolean | null {
  if (value === undefined || value.trim() === "") {
    return null;
  }
  const normalized = value.trim().toLowerCase();
  if (normalized === "true" || normalized === "1" || normalized === "yes") {
    return true;
  }
  if (normalized === "false" || normalized === "0" || normalized === "no") {
    return false;
  }
  return null;
}

export function getSamiIamDevOverride(): SamiIamDevOverride | null {
  if (typeof window === "undefined") {
    return null;
  }
  const stored = window.localStorage.getItem(SAMI_IAM_DEV_OVERRIDE_KEY);
  if (stored === "on" || stored === "off") {
    return stored;
  }
  return null;
}

export function setSamiIamDevOverride(value: SamiIamDevOverride): void {
  window.localStorage.setItem(SAMI_IAM_DEV_OVERRIDE_KEY, value);
}

/**
 * IAM is on by default outside dev mode. In dev, defaults off unless env or UI override enables it.
 */
export function isSamiIamEnabled(): boolean {
  const envOverride = parseEnvFlag(import.meta.env.VITE_SAMI_IAM_ENABLED as string | undefined);
  if (envOverride !== null) {
    return envOverride;
  }

  if (isLocalDevAppMode()) {
    const devOverride = getSamiIamDevOverride();
    if (devOverride === "on") return true;
    if (devOverride === "off") return false;
    return false;
  }

  return true;
}
